import { render, staticRenderFns } from "./PackPopup.vue?vue&type=template&id=57ec2270&scoped=true&"
import script from "./PackPopup.vue?vue&type=script&lang=ts&"
export * from "./PackPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PackPopup.vue?vue&type=style&index=0&id=57ec2270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ec2270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ec2270')) {
      api.createRecord('57ec2270', component.options)
    } else {
      api.reload('57ec2270', component.options)
    }
    module.hot.accept("./PackPopup.vue?vue&type=template&id=57ec2270&scoped=true&", function () {
      api.rerender('57ec2270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/PackPopup.vue"
export default component.exports